export const ROLE_ORDER = [
  "platform_admin",
  "tenant_owner",
  "principal",
  "administrator",
  "accountant",
  "teacher",
  "guardian",
];

export const TENANT_MANAGEMENT_ROLES = ["tenant_owner", "administrator", "principal"];

export const ROLE_LABELS = {
  platform_admin: "Platform administrator",
  tenant_owner: "Owner",
  administrator: "Administrator",
  principal: "Principal",
  accountant: "Accountant",
  teacher: "Teacher",
  guardian: "Guardian",
};

export const primaryRole = (roles = []) => {
  for (const role of ROLE_ORDER) if (roles.includes(role)) return role;
  return roles[0] || "guest";
};

export const hasAnyRole = (roles = [], allowed = []) => {
  if (roles.some((role) => allowed.includes(role))) return true;
  return roles.some((role) => TENANT_MANAGEMENT_ROLES.includes(role))
    && allowed.some((role) => TENANT_MANAGEMENT_ROLES.includes(role));
};

export const isStaff = (roles = []) =>
  hasAnyRole(roles, [
    "platform_admin",
    "tenant_owner",
    "administrator",
    "principal",
    "accountant",
    "teacher",
  ]);

export const roleLabel = (role) => ROLE_LABELS[role] || role.replaceAll("_", " ");

export const landingForRoles = (roles = []) => {
  const destination = {
    platform_admin: "/principal",
    tenant_owner: "/principal",
    principal: "/principal",
    accountant: "/fees",
    teacher: "/teacher",
    guardian: "/parent",
    administrator: "/principal",
  }[primaryRole(roles)];
  return destination || "/login";
};
